import axios from "axios";

export default {
  methods: {
    /**
     * Service para recuperar informações sobre um arquivo específico
     * @param {String, Number} id - Id único do arquivo
     * @return {Promise<{ dataEnvio: String(DataISO), dataRecebimento: String(DataISO), id: Number, nomeArquivo: String, numeroProtocolo: String, status: {chave: String, descricao: "String"}, unimedDestino: String, unimedOrigem: String, versaoPtu: String>}
     */
    getValidacaoById(id) {
      return axios.get(this.CriarUrl({ resource: "validacoes/" + id }));
    },
    /**
     * Service para baixar o relatório
     * @param {String, Number} id - Id único do arquivo
     */
    getRelatorioDownload(id) {
      return axios.get(
        this.CriarUrl(
          {
            resource: `relatorios/ptuComErros/download/selecionados`,
            params: { arquivos: id }
          },
          { apiRelatorio: true }
        ),
        {
          responseType: "blob"
        }
      );
    },
    postAprovar(id) {
      return axios.post(
        this.CriarUrl({ resource: `validacoes/${id}/aprovar` })
      );
    },
    postReprovar(id) {
      return axios.post(
        this.CriarUrl({ resource: `validacoes/${id}/reprovar` })
      );
    },
    postDesconsiderar(data) {
      return axios.post(
        this.CriarUrl({ resource: `validacoes/desconsiderarErros` }),
        data
      );
    },
    /**
     * Service para para registrar a data/hora início que usuário assumiu análise do arquivo
     * @param {String, Number} id - Id único do arquivo
     * @return {Promise<{}
     */
    postAssumirAnalise(id) {
      return axios.post(
        this.CriarUrl({ resource: `validacoes/${id}/assumirAnalise` })
      );
    }
  }
};
